import "./BooksSlide.css";

export default function BooksSlide({ autore, libri, onClose }) {
  if (!autore) return null;

  return (
    <div className="books-slide-wrapper" style={{ position: "relative" }}>

      {/* 🔥 X PREMIUM PER CHIUDERE I LIBRI */}
      <div
        onClick={onClose}
        style={{
          position: "absolute",
          top: "8px",
          right: "10px",
          fontSize: "20px",
          fontWeight: "bold",
          cursor: "pointer",
          color: "#444",
          padding: "4px 10px",
          borderRadius: "6px",
          transition: "all 0.25s ease",
          zIndex: 10
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "rgba(0,0,0,0.08)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "transparent";
        }}
      >
        ✕
      </div>

      <h3 className="books-slide-title">Libri di {autore}</h3>

      <div className="books-slide-container">
        {libri.map((libro) => (
          <div key={libro.id} className="book-card">

            {/* ⭐ COPERTINA DEL LIBRO (VERSIONE CORRETTA) */}
            {libro.copertina && (
              <img
                src={libro.copertina}
                alt={libro.titolo}
                className="book-cover"
              />
            )}

            <h4 className="book-title">{libro.titolo}</h4>
            <p className="book-category">{libro.categoria}</p>
<p> {libro.numero}</p>

          </div>
        ))}
      </div>
    </div>
  );
}
